<template>
  <div>
    <!-- eslint-disable-next-line vue/no-v-html -->
    <span v-html="parsedMessage" />
    <div v-if="showActionButtons" class="action-buttons">
      <div class="action-button like" @click="buildEvent(RateAiResponseType.LIKE)">
        <FilledLikeIcon v-if="isLikeSelected" />
        <LikeIcon v-else />
      </div>
      <div class="action-button dislike" @click="buildEvent(RateAiResponseType.DISLIKE)">
        <FilledDislikeIcon v-if="isDislikeSelected" />
        <DislikeIcon v-else />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { RateAiResponseType, RateAiResponseKind, SystemEvent } from '@/common/bot/enum';
import { AiMessageForUser, RateAiResponseEvent } from '@/common/bot/types';
import LikeIcon from '@/components/icons/LikeIcon.vue';
import FilledLikeIcon from '@/components/icons/FilledLikeIcon.vue';
import DislikeIcon from '@/components/icons/DislikeIcon.vue';
import FilledDislikeIcon from '@/components/icons/FilledDislikeIcon.vue';
import { Component, Prop, Vue } from 'vue-property-decorator';
import snarkdown from 'snarkdown';
import * as env from '@/common/environment';
import { removeMessagePrefix } from '@/common/bot/flow-frameworks/messages';
import { sanitizeHTML } from '@/common/utils';

@Component({
  components: {
    LikeIcon,
    FilledLikeIcon,
    DislikeIcon,
    FilledDislikeIcon,
  },
})
export default class AiResponseForUserMessage extends Vue {
  @Prop({ default: () => ({}) }) readonly message!: AiMessageForUser;

  readonly RateAiResponseType = RateAiResponseType;

  selectedRate: RateAiResponseKind | null = null;

  created() {
    this.selectedRate = localStorage.getItem('selectedAiRate-' + this.message.id) as RateAiResponseKind | null;
  }

  get messageText() {
    return removeMessagePrefix(this.message.message);
  }

  get showActionButtons() {
    const { rateResponse } = env.get('AI') || { rateResponse: false };
    return rateResponse;
  }

  get parsedMessage() {
    return sanitizeHTML(snarkdown(this.messageText));
  }

  get isLikeSelected() {
    return this.selectedRate === RateAiResponseType.LIKE;
  }

  get isDislikeSelected() {
    return this.selectedRate === RateAiResponseType.DISLIKE;
  }

  buildEvent(selected: RateAiResponseKind) {
    const event: RateAiResponseEvent = {
      type: SystemEvent.RATE_AI_RESPONSE,
      message: this.message,
      payload: { selected },
    };

    this.selectedRate = selected;
    localStorage.setItem('selectedAiRate-' + this.message.id, selected);

    this.$emit('send:event', event);
  }
}
</script>

<style scoped lang="scss">
@import './ActionButtonCommon.scss';

.action-buttons {
  position: absolute;
  bottom: -4px;
  right: 8px;
  transform: translateY(100%);

  display: flex;
  gap: 12px;
}

.action-button {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  transition: background-color 0.2s;
}

.like {
  color: $chat-msg-rate-like-color;
}

.dislike {
  color: $chat-msg-rate-dislike-color;
}
</style>
